<template>
  <div class="wrapper">
    <div class="structureSide">
      <!-- <el-tree
        :data="departmentGroupTree"
        :props="propsSet"
        @node-click="treeClick"
      ></el-tree> -->
      <mytree
        :searchInput="true"
        :treeData="departmentGroupTree"
        @eventUp="treeEvent"
        :prop="propsSet"
      ></mytree>
    </div>
    <div class="detailSide">
      <div class="actBar">
        <!-- <el-button type="primary" icon="el-icon-plus" size="small">
          新增角色
        </el-button>
        <el-input v-model="" size="small" placeholder="请输入角色名称"></el-input> -->
      </div>
      <div class="tableBox">
        <el-table :data="userList" border style="width: 100%" v-if="isRresh">
          <el-table-column
            type="index"
            label="序号"
            width="50"
            align="center"
            :index="
              (index) =>
                (searchCondition.pageNumber - 1) * searchCondition.pageSize +
                index +
                1
            "
          >
          </el-table-column>

          <el-table-column prop="userName" label="姓名" min-width="100">
          </el-table-column>
          <el-table-column prop="roleName" label="角色" min-width="100">
          </el-table-column>
          <el-table-column prop="mobile" label="手机" min-width="200">
          </el-table-column>
          <!-- <el-table-column prop="address" label="启用" width="300">
          </el-table-column> -->
          <!-- <el-table-column prop="zip" label="最后登录" width="120">
          </el-table-column> -->
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editUser(scope.row)"
                >编辑</el-button
              >

              <el-button type="text" size="small" @click="deleteUser(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="getUserList"
          :current-page.sync="searchCondition.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="searchCondition.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="searchCondition.total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="用户编辑"
      :visible.sync="userEditData.ifShow"
      append-to-body
      width="50%"
    >
      <el-form
        :model="userEditData"
        class="demo-form-inline"
        label-width="120px"
      >
        <el-form-item label="姓名">
          <el-input
            v-model="userEditData.userName"
            placeholder="请输入姓名"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select
            v-model="userEditData.roleId"
            style="width: 300px"
            placeholder="请选择角色"
          >
            <el-option
              v-for="(role, roleIdx) in roleList"
              :label="role.roleName"
              :value="role.id"
              :key="'role' + roleIdx"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            style="width: 300px"
            v-model="userEditData.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userEditData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="userEditData.ifShow = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="editGroupData.title"
      :visible.sync="editGroupData.ifShow"
      append-to-body
      width="50%"
    >
      <el-form
        :model="editGroupData"
        class="demo-form-inline"
        label-width="120px"
        ref="tableRef"
      >
        <el-form-item label="组织架构名">
          <el-input
            v-model="editGroupData.groupName"
            placeholder="请输入组织架构名"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="组织架构描述">
          <el-input
            v-model="editGroupData.description"
            placeholder="请输入组织架构描述"
            style="width: 300px"
          ></el-input>
        </el-form-item>
<!--        <el-form-item label="负责人" prop="userList">-->
<!--          <el-select-->
<!--            v-model="editGroupData.supervisors"-->
<!--            multiple-->
<!--            placeholder="请选择负责人"-->
<!--          >-->
<!--            <el-option-->
<!--              v-for="item in supervisorsList"-->
<!--              :key="'supervisorsId' + item.id"-->
<!--              :label="item.userName"-->
<!--              :value="item.id"-->
<!--            >-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
      </el-form>
      <!-- <el-dialog
        width="40%"
        title="选择部门"
        :visible.sync="actData.groupChosen.ifShow"
        append-to-body
      >
        双击确认选择部门
        <el-tree
          :data="departmentGroupTree"
          :props="{ label: 'groupName' }"
          @node-click="actTreeClick"
        ></el-tree>
      </el-dialog> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="editGroupData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="appendGroup">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  searchDepartmentGroup,
  getUserList,
  getRoleListNew,
  getSystemUserList,
  saveDepartmentGroup,
  editDepartmentGroup,
  deleteDepartmentGroup,
  deleteSystemUser,
} from "@/api/index";
 import mytree from "@/views/component/mytree.vue";

export default {
  data() {
    return {
        isRresh:true,
      departmentGroupTree: [],
      propsSet: {
        children: "children",
        label: "groupName",
      },
      searchCondition: {
        pageNumber: 1,
        pageSize: 10,
        departmentId: 0,
        total: 0,
      },
      userEditData: {
        ifShow: false,
        roleId: 1,
      },
      editGroupData: {
        ifShow: false,
        title: "",
        groupName: "",
        supervisors: "",
        description: "",
        parentId: 0,
      },
      editStudentData: {},
      userList: [],
      supervisorsList: [],
      roleList: [],
    };
  },
  created() {},
  mounted() {
    this.getDepartmentGroup();

    this.pageInit();
  },
  methods: {
    treeEvent(eventDetail) {
      console.log(eventDetail);
      switch (eventDetail.type) {
        case "select":
          if (eventDetail.item.id !== this.searchCondition.departmentId) {
            this.searchCondition.jumpPage = 1;
            this.searchCondition.departmentId = eventDetail.item.id;
            this.getUserList();
          }
          break;
        case "rename":
          console.log(eventDetail.item);
          eventDetail.item.supervisors =
            eventDetail.item.supervisors.split(",");
          this.editGroupData = eventDetail.item;

          Object.assign(this.editGroupData, {
            ifShow: true,
            title: "编辑部门",
          });

          break;
        case "delete":
          this.$confirm(`确认删除吗`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            deleteDepartmentGroup({
              ids: [eventDetail.item.id],
            }).then(
              (data) => {
                this.$Message.success("删除成功");
                this.getDepartmentGroup();
              },
              (data) => {
                this.$Message.error(data || "错误");
              }
            );
          });

          break;
        case "append":
          this.editGroupData = {
            ifShow: true,
            title: "添加部门",
            groupName: "",
            supervisors: [],
            description: "",
            parentId: eventDetail.parentId,
          };

          break;
        case "move":
          console.log(eventDetail);
          editDepartmentGroup({
            id: eventDetail.item.id,
            parentId: eventDetail.parentId,
          }).then(
            (data) => {
              this.$Message.success("移动成功");
              this.getDepartmentGroup();
            },
            (data) => {
              this.$Message.success(data || "移动失败");
            }
          );
          break;
        default:
          break;
      }
    },
    // studentGroupEvent(eventDetail,data) {
    //   console.log("我的妈呀",eventDetail, data);
    //   switch (eventDetail.type) {
    //     case "chosenKeysConfirm":
    //       this.editStudentData.groupIds = eventDetail.chosenKeys;
    //       break;
    //     case "select":
    //       // if (this.groupMove.ifShow) {
    //       //   this.groupMove.clickNode = eventDetail.value;
    //       //   break;
    //       // }
    //       if (eventDetail.value.id !== this.searchCondition.groupId) {
    //         this.searchCondition.jumpPage = 1;
    //         this.searchCondition.jumpPage = 1;
    //         this.searchCondition.groupId = eventDetail.value.id;
    //         // this.studentGroupInit();
    //         this.getDepartmentGroup();
    //       }
    //       break;
    //     case "rename":
    //       console.log(eventDetail.item);
    //       this.editGroupData = {
    //         ifShow: true,
    //         title: "编辑部门",
    //         groupName: eventDetail.item.groupName,
    //         supervisors:   eventDetail.item.supervisors.split(","),
    //         description: eventDetail.item.description,
    //         parentId: eventDetail.item.parentId,
    //         id:eventDetail.item.id,
    //       };
    //
    //       break;
    //     case "delete":
    //       this.$confirm(`确认删除吗`, "提示", {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning",
    //       }).then(() => {
    //         deleteDepartmentGroup({
    //           ids: [eventDetail.item.id],
    //         }).then(
    //             (data) => {
    //               this.$Message.success("删除成功");
    //               this.getDepartmentGroup();
    //             },
    //             (data) => {
    //               this.$Message.error(data || "错误");
    //             }
    //         );
    //       });
    //
    //       break;
    //     case "append":
    //       this.editGroupData = {
    //         ifShow: true,
    //         title: "添加部门",
    //         groupName: "",
    //         supervisors: [],
    //         description: "",
    //         parentId: eventDetail.parentId,
    //       };
    //
    //       break;
    //     case "move":
    //       console.log(eventDetail);
    //       editDepartmentGroup({
    //         id: eventDetail.item,
    //         parentId: eventDetail.parentId,
    //       }).then(
    //           (data) => {
    //             this.$Message.success("移动成功");
    //             this.getDepartmentGroup();
    //           },
    //           (data) => {
    //             this.$Message.success(data || "移动失败");
    //           }
    //       );
    //       break;
    //     default:
    //       break;
    //   }
    // },
      studentGroupEvent(eventDetail, treeData) {
          // console.log(type, option.chosenKeys);
          switch (eventDetail.type) {
              case "chosenKeysConfirm":
                  this.searchData.groupIds = eventDetail.chosenKeys;
                  break;
              case "rename":
                  editStudentGroup({
                      id: eventDetail.contextData.id,
                      // parentId: eventDetail.contextData.parentId,
                      groupName: eventDetail.value,
                  }).then(
                      (data) => {
                          this.$Message.success("修改成功");
                          this.studentGroupInit();
                      },
                      (data) => {
                          this.$Message.error(data || "错误");
                      }
                  );

                  break;
              case "delete":
                  deleteStudentGroup({
                      id: eventDetail.value,
                  }).then(
                      (data) => {
                          this.$Message.success("删除成功");
                          this.studentGroupInit();
                      },
                      (data) => {
                          this.$Message.error(data || "错误");
                      }
                  );
                  break;
              case "append":
                  createStudentGroup({
                      parentId: eventDetail.parentId,
                      groupName: eventDetail.title,
                  }).then(
                      (data) => {
                          this.$Message.success("创建成功");
                          this.studentGroupInit();
                      },
                      (data) => {
                          this.$Message.success(data || "创建失败");
                      }
                  );
                  break;
              case "move":
                  editStudentGroup({
                      id: eventDetail.id,
                      parentId: eventDetail.parentId,
                      // groupName: eventDetail.title,
                  }).then(
                      (data) => {
                          this.$Message.success("移动成功");
                          this.studentGroupInit();
                      },
                      (data) => {
                          this.$Message.success(data || "移动失败");
                      }
                  );
                  break;
              case "chosen":
                  console.log(eventDetail);
                  this.searchData.groupIds = eventDetail.value;
                  break;
              case "select":
                  this.temporaryTree = eventDetail.value;
                  break;
              case "confirm":
                  // this.examinationType = this.temporaryTree;
                  this.searchData.groupIds = this.temporaryTree.id;
                  break;
              default:
                  break;
          }
      },
    appendGroup() {
      saveDepartmentGroup(this.editGroupData).then((data) => {
        this.$message.success(data);
        this.editGroupData.ifShow = false;
        this.getDepartmentGroup();
      });
    },
    treeClick() {},
    getUserList() {
      getUserList(this.searchCondition).then((data) => {
        this.userList = data.rows;
        this.searchCondition.total = data.total;
      });
    },
    editUser(item) {
      Object.assign(this.userEditData, item);
      this.userEditData.ifShow = true;
    },
    deleteUser(item) {
      const title ='温馨提醒';
      const content ='确定要删除吗！删除后无法恢复';
      this.$Modal.error({
        title: title,
        content: content,
        closable:true,
        onOk:function(){
            console.log("点了吗",item);
          deleteSystemUser({id:item.id}).then((data) => {

            this.$Message.success(data || "删除失败");
            this.isRresh = false;
            this.$nextTick(()=>{
                this.isRresh=true;
            })
              getSystemUserList({
                  pageNumber: 1,
                  pageSize: 1000,
                  departmentId: item.groupId,
              }).then((data) => {
                  this.supervisorsList = data.rows;
              });

          });
        }
      });
    },
    getDepartmentGroup() {
      searchDepartmentGroup().then((data) => {
        data.unshift({
          groupName: "所有组织架构",
          id: 0,
          parentId: 0,
          children: [],
        });
        this.departmentGroupTree = data;
      });
    },
    pageInit() {
      getRoleListNew().then((data) => {
        console.log(data.rows);
        this.roleList = data.rows;
      });
      this.getUserList();
      getSystemUserList({
        pageNumber: 1,
        pageSize: 1000,
        departmentId: 0,
      }).then((data) => {
        this.supervisorsList = data.rows;
      });
    },
  },
  components: { mytree },
};
</script>

<style scoped lang="less">
.wrapper {
  display: flex;
  min-height: 60vh;
  width: 80%;
  margin: auto;
  .structureSide {
    flex: 1;
    min-width: 200px;
    margin-right: 10px;
    background: #fff;
  }
  .detailSide {
    flex: 5;
    background: #fff;
    padding: 20px;
  }
}
</style>
